import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isNearActive, pagesPropTypes } from '../helpers';
import HeidelbergPage from './HeidelbergPage';

import './HeidelbergBook.scss';

const HeidelbergBook = props => (
  <div
    className={cx('Heidelberg-Book', {
      'is-ready': props.pages.length > 0,
      'at-front-cover': props.atFrontCover,
      'at-rear-cover': props.atBackCover,
    })} >
    {props.pages.map(page => (
      <HeidelbergPage
        key={page.id}
        id={page.id}
        imageUrl={page.url}
        active={props.activeSpread.includes(page.id)}
        nearActive={isNearActive(page.id, props.activeSpread)}
        onIncrement={props.handleIncrement}
        onDecrement={props.handleDecrement}>
        {page.content}
      </HeidelbergPage>
    ))}
  </div>
);

HeidelbergBook.propTypes = {
  pages: pagesPropTypes.isRequired,
  atFrontCover: PropTypes.bool.isRequired,
  atBackCover: PropTypes.bool.isRequired,
  activeSpread: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleDecrement: PropTypes.func.isRequired,
  handleIncrement: PropTypes.func.isRequired,
};

export default HeidelbergBook;



// WEBPACK FOOTER //
// ./src/client/js/view/components/BookPreview/HeidelbergBook/HeidelbergBook.js